import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { API_URLS } from '../../app/shared/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  // Remplace cette clé par ta clé VAPID publique
  readonly VAPID_PUBLIC_KEY = 'BPS22QjYB6KvuP21jXIYd5CnW8ux1ttzef90Hcq1xUQEXpEAzoBcIklieoJxegt9cgHbDtDuViWQ5t_4XUquvy4';
  notifications: {
    title: string;
    body: string;
    icon?: string;
    image?: string;
    url?: string;
  }[] = [];

  constructor(private swPush: SwPush, private http: HttpClient) {}

  public async requestPermission(): Promise<void> {
    if (this.swPush.isEnabled) {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        console.log('Permission de notification accordée.');
      } else {
        console.warn('Permission de notification refusée.');
      }
    } else {
      console.warn('Les services workers ne sont pas activés sur ce naviguateur');
    }
  }

  // Demande l'autorisation et envoie l'abonnement au backend
  async subscribeToNotifications() {
    await this.requestPermission();
    this.swPush
      .requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      })
      .then((subscription) => {
        console.log('Abonnement réussi', subscription);
        // Envoi de l’abonnement au backend
        this.http
          .post(API_URLS.NOTIFICATIONS.SUBSCRIBE, subscription)
          .subscribe({
            next: () => console.log('Abonnement envoyé au serveur'),
            error: (error) => console.error('Erreur lors de l\'envoi au backend', error.message),
          });
      })
      .catch((error) => console.error('Erreur abonnement push', error.message));
  }

  // Gère la réception des notifications (facultatif pour afficher dans l'app directement)
  listenToMessages() {
    this.swPush.messages.subscribe((message: any) => {
      console.log('Notification reçue');
      // Ici, tu peux afficher une alerte dans l'app par exemple

      try {
        // Certaines implémentations envoient le payload brut en string
        // if (typeof message === 'string') {
        //   message = JSON.parse(message);
        // }

        // Afficher la notification ici en utilisant l'API Notification du navigateur
        const notificationTitle = message.title || 'Nouvelle notification';
        const notificationOptions = {
          body: message.body || 'aucun message',
          icon: message.icon || '/icons/icon-128x128.png',
          data: message.data || {}
        };
        navigator.serviceWorker.getRegistration().then(reg => {
          reg?.showNotification(notificationTitle, notificationOptions);
        });

        this.swPush.notificationClicks.subscribe(event => {
          console.log('Notification clicked: ', event);
          const notificationData = event.notification.data;
          if (notificationData?.url) {
            window.open(notificationData.url, '_blank');
          }
        });

      } catch (error) {
        console.error('Erreur de parsing du message push :', error);
      }
    });

    this.swPush.notificationClicks.subscribe((event) => {
      console.log('Notification cliquée', event);
    });
  }
}
